import client from '@js/client'
import resources from '@js/resources'
import { snakeKeyToCamelKeyRecursive } from '@js/str-utils'

const getDefaultState = () => {
  return {
    experiencePeriodCategories: [],
    languageCodes: [],
    skillStatusTypes: [],
    timezoneCodes: [],
  };
};

const serviceParams = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getIndexByLanguageCode: state => code => {
      if (state.languageCodes.length === 0) {
        return null;
      }
      code = code ? code.toLowerCase() : '';
      const index = state.languageCodes.findIndex(
        elem => elem.code.toLowerCase() === code);
      return index < 0 ? null : index;
    },
    getLanguageCodeByIndex: state => index => {
      if (index >= state.languageCodes.length || index < 0) {
        return null;
      }
      return state.langauageCodes[index].code;
    },
    getIndexByTimezoneCode: state => code => {
      if (state.timezoneCodes.length === 0) {
        return null;
      }
      code = code ? code.toLowerCase() : 'N/A'.toLowerCase();
      const index = state.timezoneCodes.findIndex(
        elem => elem.name.toLowerCase() === code);
      return index < 0 ? null : index;
    },
    getTimezoneCodeByIndex: state => index => {
      if (index >= state.timezoneCodes.length || index < 0) {
        return null;
      }
      return state.timezoneCodes[index].code;
    },
  },
  mutations: {
    initialize (state) {
      Object.assign(state, getDefaultState());
    },
    setExperiencePeriodCategories (state, data) {
      state.experiencePeriodCategories = data.reduce((result, elem) => {
        result.push(snakeKeyToCamelKeyRecursive(elem));
        return result;
      }, []);
      state.experiencePeriodCategories.sort(
        (a, b) => a.displayOrder > b.displayOrder);
    },
    setLanguageCodes (state, data) {
      state.languageCodes = data.reduce((result, elem) => {
        result.push(snakeKeyToCamelKeyRecursive(elem));
        return result;
      }, []);
    },
    setSkillStatusTypes (state, data) {
      state.skillStatusTypes = data.reduce((result, elem) => {
        result.push(snakeKeyToCamelKeyRecursive(elem));
        return result;
      }, []);
      state.skillStatusTypes.sort((a, b) => a.displayOrder > b.displayOrder);
    },
    setTimezoneCodes (state, data) {
      state.timezoneCodes = data.reduce((result, elem) => {
        result.push(snakeKeyToCamelKeyRecursive(elem));
        return result;
      }, []);
    },
  },
  actions: {
    async fetchAllServiceParams({ dispatch }) {
      await dispatch('fetchExperiencePeriodCategories');
      await dispatch('fetchLanguageCodes');
      await dispatch('fetchSkillStatusTypes');
      await dispatch('fetchTimezoneCodes');
    },
    async fetchExperiencePeriodCategories ({ state, commit, rootGetters }) {
      const res = await client.get(resources['experiencePeriodCategories']);
      await commit('setExperiencePeriodCategories', res.data);
      return res;
    },
    async fetchLanguageCodes ({ state, commit, rootGetters }) {
      const res = await client.get(resources['languageCodes']);
      await commit('setLanguageCodes', res.data);
      return res;
    },
    async fetchSkillStatusTypes ({ state, commit, rootGetters }) {
      const res = await client.get(resources['skillStatusTypes']);
      await commit('setSkillStatusTypes', res.data);
      return res;
    },
    async fetchTimezoneCodes ({ state, commit, rootGetters }) {
      const res = await client.get(resources['timezoneCodes']);
      await commit('setTimezoneCodes', res.data);
      return res;
    },
  },
};

export default serviceParams;
